import { isInternetExplorer } from '@uipath/angular/utilities';

const addParamToUrl = (url: string, paramName: string, paramValue: string): string => {
    const searchIndex = url.lastIndexOf('?');

    const parameter = `${encodeURIComponent(paramName)}=${encodeURIComponent(paramValue)}`;
    if (searchIndex >= 0) {
        return `${url}&${parameter}`;
    }
    return `${url}?${parameter}`;
};

export class WindowFunctions {
    public static windowHrefRedirect(destination: string, params?: Record<string, string>) {
        let newUrl = destination;
        if (params != null) {
            Object.keys(params).forEach(key => newUrl = addParamToUrl(newUrl, key, params[key]));
        }

        if (isInternetExplorer()) {
            newUrl = window.location.origin + '/' + newUrl;
        }

        window.location.href = newUrl;
    }
}
